module.exports = __webpack_public_path__ + "img/T2B_xh_12.0e45628f.png";